import * as React from "react";
import ReactSelect from ".";
import { Props } from "react-select";
import { useQuery } from "react-query";
import axios from "axios";
import { TTax } from "types/tax";
import Field from "components/field";
import { useTranslation } from "react-i18next";

type TProps = Omit<Props, "value"> & {
  taxOnly?: boolean;
};

const TaxSelectSettings = (props: TProps) => {
  const { t } = useTranslation();
  const tBase = "components.react-select";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const fetchTaxOptions = useQuery(
    "taxOptions",
    async () =>
      await axios
        .get(
          `
      ${process.env.REACT_APP_SERVER_URL}/api/v1/company/tax/both
      `
        )
        .then((res) => res.data)
  );

  const allOptions = React.useMemo(
    () => [...(fetchTaxOptions.data?.taxes || []), ...(fetchTaxOptions.data?.taxGroups || [])],
    [fetchTaxOptions.data]
  );

  const formatVal = React.useMemo(
    () => allOptions.find((item: any) => item.id === props.value) || "",
    [allOptions, props.value]
  );

  const filteredOptions = React.useMemo(
    () =>
      allOptions.filter((item: any) => {
        if (props.taxOnly) {
          if (item.tax_type === "tax") {
            return true;
          }
          if (item.taxes && Array.isArray(item.taxes)) {
            return item.taxes.every((tax: any) => tax.tax_type === "tax");
          }
          return false;
        }
        return true;
      }),
    [allOptions, props.taxOnly]
  );

  if (!fetchTaxOptions.isSuccess) return null;

  return (
    <Field
      type="select"
      style={{ width: "100%" }}
      options={filteredOptions?.map((item: any) => ({
        ...item,
        value: item.id,
        label: item.taxes && Array.isArray(item.taxes) ? `${item.label} (Group)` : item.label,
      }))}
      name="select"
      placeholder={tr("Select a tax")}
      {...props}
      value={formatVal}
    />
  );
};

export default TaxSelectSettings;
